import controller from './folder-path.controller';

const template = require('./folder-path.html');

export default {
    bindings: {
        folderId: '<',
        emptyTrail: '<',
        maxWidth: '<',
        fontSize: '@'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/common/folder-path/folder-path.component.js